Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'conversation',
      branch: 'conversations',
      depth: 1
    });
  }

  onActive() {
    let conversationId = this._state;
    let conversation = Conversations.get(conversationId);
    if (!conversation)  {
      this.setState(null);
      conversation = Conversations.get(null);
    }

    if (!conversation) Views.jumpToViewByName('conversations');
    else if (conversation.id && conversation.ephemeral && !conversation.isOpened()) {
      this.setState(null);
      Views.jumpToViewByName('conversations');
    }
    else Conversations._open(conversation);
  }

  chatInput() {
    if (!Conversations.didUserCommitToNewConversation() && Conversations.waitingForBotTree(Conversations.current) === true) {
      return 'get_started';
    }
    else if (Conversations.shouldDisplayInput()) {
      return 'input';
    }
    else return null;
  }

  mainTitle() {
    let conversation = Conversations.current;
    let team = Teams.find(conversation.user_group_id);
    if (team)
      return team.name;
    else
      return Wording.window_title;
  }

  smallTitle() {
    let conversation = Conversations.current;
    let team = Teams.findOrDefault(conversation.user_group_id);
    if (conversation.ephemeral)
      return Wording.new_ephemeral_conversation_text;
    if (!conversation.id)
      return Wording.new_conversation_text;
    if (team && team.kind == "many")
      return `<span class="slaask-widget-notify-title-span-online" id="slaask-widget-notify-title-span" style="color: ${this.app._title_color}">${Wording.online_users_text} <span id="slaask-widget-online-count">${Wording.loading_button_value}</span></span>`;
    return this.app._createTimeAgo(null, conversation.last_activity).innerHTML;
  }

  syncTitle() {
    super.syncTitle();
    const conversation = Conversations.current;
    const header = Dom.findById('widget', 'slaask-widget-header');
    if (header) {
      if (conversation && conversation.ephemeral) {
        header.classList.add('slaask-widget-header-ephemeral');
      } else {
        header.classList.remove('slaask-widget-header-ephemeral');
      }
    }
  }

  onLeave() {
    super.onLeave();
    const header = Dom.findById('widget', 'slaask-widget-header');
    if (header) header.classList.remove('slaask-widget-header-ephemeral');
  }

  initEventListeners() {
    let findA = elementRoot => {
      let elementCursor = elementRoot;
      while (elementCursor && elementCursor != this.element && elementCursor != elementCursor.parentElement) {
        if (elementCursor.tagName == "A") return elementCursor;
        elementCursor = elementCursor.parentElement;
      }
      return false;
    };
    this.element.addEventListener('click', event => {
      let linkElement = findA(event.target);
      if (linkElement) {
        if (this.app._isHelpCenterUrl(linkElement.href)) {
          event.preventDefault();

          const params = Utils.getUrlParams(linkElement.href);
          params.iframe = "true";
          const url = Utils.setUrlParams(linkElement.href, params);
          Views.jumpToViewByName('iframe', url);
        }
      }
    });
  }

  _htmlBase() {
    return ``; // Set in Conversations.js@_open
  }

});
